export default "__VITE_PUBLIC_ASSET__53c4187f__"